export const routes = [
  ...require('./danfe-integration/routes').routes
]
